$(document).ready(function(){
  $(".announcement_slider").slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    variableWidth: true,
    cssEase: 'linear',
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    swipeToSlide: true,
    centerMode: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        }
      }
    ]
  });
  $('.product_img_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows:false,
    dots: true,
    autoplay:true,
    autoplaySpeed:4000,
  });

  $('.home_video_btn').on('click',function(e){
    e.preventDefault();
    $('body').addClass('home_video_active');
    $(this).parents('.home_video_block').next('.home_video_popup').addClass('active');
  });
  
  
  var Froogaloop=function(){function e(a){return new e.fn.init(a)}function g(a,c,b){if(!b.contentWindow.postMessage)return!1;a=JSON.stringify({method:a,value:c});b.contentWindow.postMessage(a,h)}function l(a){var c,b;try{c=JSON.parse(a.data),b=c.event||c.method}catch(e){}"ready"!=b||k||(k=!0);if(!/^https?:\/\/player.vimeo.com/.test(a.origin))return!1;"*"===h&&(h=a.origin);a=c.value;var m=c.data,f=""===f?null:c.player_id;c=f?d[f][b]:d[b];b=[];if(!c)return!1;void 0!==a&&b.push(a);m&&b.push(m);f&&b.push(f);
return 0<b.length?c.apply(null,b):c.call()}function n(a,c,b){b?(d[b]||(d[b]={}),d[b][a]=c):d[a]=c}var d={},k=!1,h="*";e.fn=e.prototype={element:null,init:function(a){"string"===typeof a&&(a=document.getElementById(a));this.element=a;return this},api:function(a,c){if(!this.element||!a)return!1;var b=this.element,d=""!==b.id?b.id:null,e=c&&c.constructor&&c.call&&c.apply?null:c,f=c&&c.constructor&&c.call&&c.apply?c:null;f&&n(a,f,d);g(a,e,b);return this},addEvent:function(a,c){if(!this.element)return!1;
var b=this.element,d=""!==b.id?b.id:null;n(a,c,d);"ready"!=a?g("addEventListener",a,b):"ready"==a&&k&&c.call(null,d);return this},removeEvent:function(a){if(!this.element)return!1;var c=this.element,b=""!==c.id?c.id:null;a:{if(b&&d[b]){if(!d[b][a]){b=!1;break a}d[b][a]=null}else{if(!d[a]){b=!1;break a}d[a]=null}b=!0}"ready"!=a&&b&&g("removeEventListener",a,c)}};e.fn.init.prototype=e.fn;window.addEventListener?window.addEventListener("message",l,!1):window.attachEvent("onmessage",l);return window.Froogaloop=
  window.$f=e}();
  
  $('.home_video_popup,.home_video_close').on('click',function(e){
    
    
    e.preventDefault();
    $('.home_video_popup').removeClass('active');
    $('body').removeClass('home_video_active');

    var iframe = $('#iframe-video-1')[0];
    var player = $f(iframe);
    player.api('pause');
    
    
    var iframe1 = $('#iframe-video-2')[0];
    var player1 = $f(iframe1);
    player1.api('pause');

    
  });
  
  
  
  
  
  
  
  
  $('.header_menu').on('click',function(e){
    e.preventDefault();
    $('body').addClass('menu_active');
    if($('.section-header').hasClass('shopify-section-header-sticky')){
      $('.mb_menu').css('top','0px');
    }else{
      var height = $('.announcement_bar').innerHeight();
      $('.mb_menu').css('top',height+'px');
    }
    
  });
  $('.mb_menu_close').on('click',function(e){
    e.preventDefault();
    $('body').removeClass('menu_active');
  });
  
  $(document).on('click', 'body', function(e){
    var tag = $('.mb_menu,.header_menu');
    if (!tag.is(e.target) && tag.has(e.target).length === 0) {
      $('body').removeClass('menu_active');
    }
  });

  $('.header_cart').on('click',function(e){
    e.preventDefault();
    $('body').addClass('cart_active');
    var height = $('.cart_drawer_header').innerHeight() + $('.cart_drawer_footer').innerHeight();
    $('#cart_container_id').css('height','calc(100% - '+ height +'px)');
  });

  $('.cart_close,.menu_drawer_overly').on('click',function(e){
    e.preventDefault();
    $('body').removeClass('cart_active');
  });

  $(document).on('click', 'body', function(e){
    var tag = $('.cart_item,.header_cart');
    if (!tag.is(e.target) && tag.has(e.target).length === 0) {
      $('body').removeClass('cart_active');
    }
  });

  // $(document).on("click" ,".home_banner_to_firstpro,.scroll_to_first_pro", function(event){
  //   var destination = $('#first_pro_section').offset().top;
  //   if ($('#first_pro_section').length > 0) {
  //     event.preventDefault()
  //     $('body').removeClass('cart_active menu_active');
  //     $("html:not(:animated),body:not(:animated)").animate({ scrollTop: destination }, 1500);
      
  //     return false;
  //   }
  // });
  
  // setTimeout(function () {
  //   $('.popup--newsletter').show();
  //   $('.popup--newsletter').parents('body').addClass('popup_newsletter_active');
  // }, 10000);

  // $('.popup-close-model, .popup--close__model').click(function() {
  //   $(this).parents('.popup--newsletter').hide();
  //   $('body').removeClass('popup_newsletter_active');
  // });
  
  // cookies
  function setCookie(cname,cvalue,exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkCookie() {
    let user = getCookie("newsletter");
    // if (user != "") {
    if (false) {
      $('.popup--newsletter').hide()
      $('body').removeClass('popup_newsletter_active');
    } else {
      setTimeout(function(){
        $('.popup--newsletter').show();
        $('.popup--newsletter').parents('body').addClass('popup_newsletter_active');
      }, 10000);
    }
  }
  checkCookie();

  $('.popup-close-model, .popup--close__model').click(function(){
    $(this).parents('.popup--newsletter').hide();
    $('body').removeClass('popup_newsletter_active');
    setCookie("newsletter", "hide", 7);
    $('.popup--newsletter').hide()
    $('body').removeClass('popup_newsletter_active');
  });
  
  
});

function cart_drawer(){
  var height = $('.cart_drawer_header').innerHeight() + $('.cart_drawer_footer').innerHeight();
  $('#cart_container_id').css('height','calc(100% - '+ height +'px)');
}
function menu_drawer(){
  var height = $('.announcement_bar').innerHeight();
  $('.mb_menu').css('top',height+'px');
}
$(document).ready(function(){
  cart_drawer();
  menu_drawer()
});
$(document).on('load',function(){
  cart_drawer();
  menu_drawer()
});
$(window).resize(function() {
  cart_drawer();
  menu_drawer()
});